export const industryOptions = [
    {
        label: 'Car Dealers, Garages & Mechanics',
        mappedValue: 'motor',
        value: 'Car Dealers, Garages & Mechanics'
    },
    {
        label: 'Construction',
        mappedValue: 'construction',
        value: 'Construction'
    },
    {
        label: 'Hotels, Restaurants & Pubs',
        mappedValue: 'hospitality',
        value: 'Hotels, Restaurants & Pubs'
    },
    {
        label: 'Manufacturing, Food Processing & Printing',
        mappedValue: 'manufacturing',
        value: 'Manufacturing, Food Processing & Printing'
    },
    {
        label: 'Retail',
        mappedValue: 'retail',
        value: 'Retail',
        helper: 'online or offline'
    },
    {
        label: 'Wholesale',
        mappedValue: 'wholesale',
        value: 'Wholesale'
    },
    {
        label: 'Agriculture, Forestry & Fishing',
        mappedValue: 'agriculture',
        value: 'Agriculture, Forestry & Fishing'
    },
    {
        label: 'Architecture & Engineering',
        mappedValue: 'engineering',
        value: 'Architecture & Engineering'
    },
    {
        label: 'Business Support Services',
        mappedValue: 'business_support',
        value: 'Business Support Services'
    },
    {
        label: 'Cleaning, Landscaping & Gardening',
        mappedValue: 'cleaning',
        value: 'Cleaning, Landscaping & Gardening'
    },
    {
        label: 'Education & Training',
        mappedValue: 'education',
        value: 'Education & Training'
    },
    {
        label: 'Finance & Insurance',
        mappedValue: 'finance',
        value: 'Finance & Insurance'
    },
    {
        label: 'Health & Care',
        mappedValue: 'health',
        value: 'Health & Care'
    },
    {
        label: 'IT & Communications',
        mappedValue: 'it',
        value: 'IT & Communications'
    },
    {
        label: 'Leisure / Other Services',
        mappedValue: 'leisure',
        value: 'Leisure / Other Services'
    },
    {
        label: 'Professional Services',
        mappedValue: 'professional_services',
        value: 'Professional Services'
    },
    {
        label: 'Property & Real Estate',
        mappedValue: 'property',
        value: 'Property & Real Estate'
    },
    {
        label: 'Publishing, Film & Media Production',
        mappedValue: 'media',
        value: 'Publishing, Film & Media Production'
    },
    {
        label: 'Transport & Logistics',
        mappedValue: 'transport',
        value: 'Transport & Logistics'
    },
    {
        label: 'Other',
        mappedValue: 'other',
        value: 'Other'
    }
];
